import http from '../utils/http';
import {
  MY_JOBS,
  OTHER_JOBS,
  SORT_JOBS,
  FILTERS,
  SET_SUBMITTING,
  SET_STC_FILTER,
  SET_CC_FILTER,
  SET_DISTRIBUTOR_FILTER,
  SET_OFFSET,
  CLEAR_FILTERS,
} from '../constants/actionTypes';

import { setFeedbackAction } from './feedback';

import {
  myJobsUrl,
  otherJobsUrl,
  tagJobUrl,
} from '../constants/urls';

import { jobTypes } from '../constants/job';

const setMyJobsAction = myJobs => ({
  type: MY_JOBS,
  payload: myJobs,
});

const setFiltersSubmittingAction = isSubmitting => ({
  type: SET_SUBMITTING,
  payload: isSubmitting
});

const setOtherJobsAction = otherJobs => ({
  type: OTHER_JOBS,
  payload: otherJobs,
});

export const setSorting = sort => ({
  type: SORT_JOBS,
  payload: sort,
});

export const setFilters = filters => ({
  type: FILTERS,
  payload: filters,
})

export const setSTCFilter = STCs => ({
  type: SET_STC_FILTER,
  payload: STCs,
})

export const setCCFilter = CCs => ({
  type: SET_CC_FILTER,
  payload: CCs,
})

export const setDistributorFilter = distributors => ({
  type: SET_DISTRIBUTOR_FILTER,
  payload: distributors,
})

export const setOffset = (offsetType, offset) => ({
  type: SET_OFFSET,
  offsetType,
  offset,
})

export const setFiltersSubmitting = isSubmitting => dispatch => dispatch(setFiltersSubmittingAction(isSubmitting));

export const clearFilters = () => ({ type: CLEAR_FILTERS })

export const getMyJobs = (filters = {}, limit = 10, packData) => {

  const filtersBeforeChanges = {...filters.filter};

  // Pack data to match API
  if (packData !== 'no') {
    filters.filter.status = Object.keys(filters.filter.status).reduce((filterArray, key) => {
      return filters.filter.status[key]
            ? [...filterArray, {[key] : filters.filter.status[key]}]
            : filterArray
    }, []);
  }
  

  return async (dispatch, getState) => {
    try {
      dispatch(setFiltersSubmitting(true));
      const
      { data: response } = await http.post(myJobsUrl(getState().jobs.offsets.myJobsOffset, limit), filters),
      myJobs = response.data;
      packData !== 'no' && await dispatch(setFilters(filtersBeforeChanges));

      sessionStorage.setItem(jobTypes.my, JSON.stringify(myJobs));
      dispatch(setMyJobsAction(myJobs));

      return true;
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
      return true;
    } finally{
      dispatch(setFiltersSubmitting(false));
    }
  }
}

export const getOtherJobs = (filters = {}, limit = 10, packData) => {

  const filtersBeforeChanges = {...filters.filter}
  
  // Pack data to match API
  if (packData === 'yes') {
    filters.filter.status = Object.keys(filters.filter.status).reduce((filterArray, key) => {
      return filters.filter.status[key]
             ? [...filterArray, {[key] : filters.filter.status[key]}]
             : filterArray
    }, []);
  }

  return async (dispatch, getState) => {
    try {
      dispatch(setFiltersSubmitting(true));

      const
      { data: response } = await http.post(otherJobsUrl(getState().jobs.offsets.otherJobsOffset, limit), filters),
      otherJobs = response.data;
      packData === 'yes' && await dispatch(setFilters(filtersBeforeChanges));


      dispatch(setOtherJobsAction(otherJobs));
      sessionStorage.setItem(jobTypes.other, JSON.stringify(otherJobs));

      return true;
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
      return true;
    } finally{
      dispatch(setFiltersSubmitting(false));
    }
  }
};

/*
 * data = { tagged: boolean }
 */
export const tagJob = (jobId, data) =>
  dispatch => {
    try {
      http.put(tagJobUrl(jobId), data);

      // No need to locally save data because UI should update only if
      // page is refreshed or accessed again
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }



// WEBPACK FOOTER //
// ./src/actions/jobs.js